// Shareable Safety Card — the "Have a REAL good time." North Star card as a 1080x1080 PNG.
// Verbatim lines (never alter): "1+ in 10 women experience drink-spiking — know the signs!" and
// "Learn at THE WALL: LOOKWASHINGTON.com/DRINKS".
import { renderGuideCard, downloadGuideCard, shareGuideCard } from "./guideShareCard";

export const NORTH_STAR_CARD = {
  color: "#1D4ED8",
  brand: "THE WALL · The North Star Guide",
  eyebrow: "Drink & Food Spiking — Protecting People Professionally",
  title: "Have a REAL good time.",
  lede: "Desire is natural — drugs that induce desire violate your consent. Protect yourself & friends: know the signs of food & drink spiking and know the symptoms of the drugs used — in case something happens.",
  alert_title: "New & deadly: Cychlorphine",
  alert_body: "A synthetic opioid ~10× more potent than fentanyl, now in Washington. Test strips and routine screens don't detect it. Unresponsive or breathing slowly? Call 911, give Narcan, keep giving it. — KING 5 NEWS",
  tell_label: "The tell",
  tell_body: "How you feel vs. what you actually drank. When those don't match — say so, stay together, get checked. Hours matter.",
  footer_line: "1+ in 10 women experience drink-spiking — know the signs!",
  link_line: "Learn at THE WALL: LOOKWASHINGTON.com/DRINKS",
};

const FILE = "have-a-real-good-time-north-star.png";
const SHARE_TEXT = "Have a REAL good time. 1+ in 10 women experience drink-spiking — know the signs! Learn at THE WALL: LOOKWASHINGTON.com/DRINKS";

export const renderSafetyShareCard = () => renderGuideCard(NORTH_STAR_CARD);
export const downloadSafetyShareCard = () => downloadGuideCard(NORTH_STAR_CARD, FILE);
export const shareSafetyCard = () => shareGuideCard(NORTH_STAR_CARD, FILE, SHARE_TEXT);
